(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const cardSelector = '[data-collection-variant-card]';

    function updateVariantLinks(card) {
      const variantUrl = card.dataset.variantUrl;
      const productUrl = card.dataset.productUrl;

      if (!variantUrl || !productUrl) return;

      let productPath;

      try {
        productPath = new URL(productUrl, window.location.origin).pathname;
      } catch (error) {
        return;
      }

      card.querySelectorAll('a[href]').forEach((link) => {
        try {
          const currentUrl = new URL(link.href, window.location.origin);

          if (currentUrl.pathname === productPath) {
            link.href = variantUrl;
          }
        } catch (error) {
          // Pomijamy linki, których nie można przetworzyć.
        }
      });

      const productCard = card.querySelector('product-card');

      if (!productCard) return;

      const productCardLink = productCard.querySelector('[ref="productCardLink"]');

      if (productCardLink) {
        productCardLink.href = variantUrl;

        if (productCardLink.id) {
          productCardLink.id = `${productCardLink.id}-${card.dataset.variantId}`;
        }
      }

      if (productCard.id) {
        productCard.id = `${productCard.id}-${card.dataset.variantId}`;
      }

      const variantImageUrl = card.dataset.variantImageUrl;

      productCard.setAttribute('data-product-id', card.dataset.productId || '');
      productCard.setAttribute('data-variant-id', card.dataset.variantId || '');

      const gallery = card.querySelector('.card-gallery');

      if (gallery) {
        gallery.setAttribute('data-variant-id', card.dataset.variantId || '');
      }

      if (variantImageUrl) {
        productCard.setAttribute('data-featured-media-url', variantImageUrl);
      }
    }

    function updateSelectedVariant(card) {
      const variantId = card.dataset.variantId;
      const available = card.dataset.variantAvailable === 'true';
      const productCard = card.querySelector('product-card');

      if (!variantId || !productCard) return;

      /*
       * Usuwamy zaznaczenie domyślnego wariantu z ukrytych próbek,
       * żeby szybki podgląd korzystał z wariantu przypisanego do kafelka.
       */
      productCard
        .querySelectorAll('input[type="radio"][data-variant-id]:checked')
        .forEach((input) => {
          input.checked = false;
        });

      let selectedVariantInput = productCard.querySelector(
        '[data-collection-selected-variant]'
      );

      if (!selectedVariantInput) {
        selectedVariantInput = document.createElement('input');
        selectedVariantInput.type = 'radio';
        selectedVariantInput.hidden = true;
        selectedVariantInput.checked = true;
        selectedVariantInput.setAttribute(
          'data-collection-selected-variant',
          ''
        );

        productCard.appendChild(selectedVariantInput);
      }

      selectedVariantInput.name = `collection-variant-${card.dataset.productId}-${variantId}`;
      selectedVariantInput.value = variantId;
      selectedVariantInput.dataset.variantId = variantId;
      selectedVariantInput.checked = true;

      /*
       * Formularz szybkiego dodawania do koszyka.
       */
      productCard
        .querySelectorAll('input[name="id"]')
        .forEach((input) => {
          input.value = variantId;
          input.disabled = !available;
        });

      productCard
        .querySelectorAll(
          '.quick-add__button--add, .add-to-cart-button[type="submit"]'
        )
        .forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
    }

    function updateVariantPrice(card) {
      const priceTemplate = card.querySelector(
        'template[data-collection-variant-price]'
      );

      if (!priceTemplate) return;

      card
        .querySelectorAll('[ref="priceContainer"]')
        .forEach((priceContainer) => {
          priceContainer.replaceChildren(
            priceTemplate.content.cloneNode(true)
          );
        });

      card
        .querySelectorAll('[ref="volumePricingNote"]')
        .forEach((volumePricingNote) => {
          volumePricingNote.hidden = true;
        });
    }

    function replaceImageFallback(card) {
      const imageUrl = card.dataset.variantImageUrl;
      const imageSrcset = card.dataset.variantImageSrcset;
      const imageAlt = card.dataset.variantImageAlt;

      if (!imageUrl) return;

      const image = card.querySelector(
        '.card-gallery .product-media__image'
      );

      if (!image) return;

      image.src = imageUrl;

      if (imageSrcset) {
        image.srcset = imageSrcset;
      }

      if (imageAlt) {
        image.alt = imageAlt;
      }

      image.setAttribute('data-max-resolution', imageUrl);

      const picture = image.closest('picture');

      if (picture && imageSrcset) {
        picture.querySelectorAll('source').forEach((source) => {
          source.srcset = imageSrcset;
        });
      }
    }

    function updateVariantImage(card) {
      const mediaId = card.dataset.variantMediaId;
      const slideshow = card.querySelector(
        '.card-gallery slideshow-component'
      );
      const gallery = card.querySelector('.card-gallery');

      /*
       * Wyłączamy zmianę zdjęcia po najechaniu, ponieważ każdy kafelek
       * ma pozostać przypisany do konkretnego koloru.
       */
      if (gallery && card.dataset.hasColorOption === 'true') {
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
      }

      if (!slideshow || !mediaId) {
        replaceImageFallback(card);
        return;
      }

      const slides = Array.from(
        slideshow.querySelectorAll('slideshow-slide')
      );

      const selectedSlide = slides.find(
        (slide) => slide.getAttribute('slide-id') === mediaId
      );

      if (!selectedSlide) {
        replaceImageFallback(card);
        return;
      }

      const selectedSlideIndex = slides.indexOf(selectedSlide);

      if (selectedSlideIndex >= 0) {
        slideshow.setAttribute(
          'initial-slide',
          String(selectedSlideIndex)
        );
      }

      const selectSlide = (attempt = 0) => {
        if (
          typeof slideshow.select === 'function' &&
          slideshow.isConnected
        ) {
          slideshow.select(
            { id: mediaId },
            undefined,
            { animate: false }
          );

          return;
        }

        if (attempt < 10) {
          requestAnimationFrame(() => {
            selectSlide(attempt + 1);
          });
        } else {
          replaceImageFallback(card);
        }
      };

      if (window.customElements) {
        customElements
          .whenDefined('slideshow-component')
          .then(() => {
            requestAnimationFrame(() => {
              selectSlide();
            });
          })
          .catch(() => {
            replaceImageFallback(card);
          });
      } else {
        replaceImageFallback(card);
      }
    }

    function updateAriaLabels(card) {
      const productTitle = card.dataset.productTitle;
      const colorName = card.dataset.colorName;

      if (!productTitle) return;

      const ariaLabel =
        colorName && card.dataset.hasColorOption === 'true'
          ? `${productTitle} – ${colorName}`
          : productTitle;

      card
        .querySelectorAll(
          '[ref="productCardLink"], [ref="cardGalleryLink"]'
        )
        .forEach((link) => {
          link.setAttribute('aria-label', ariaLabel);
        });
    }

    /*
     * BADGES / LABELS / STICKERS
     *
     * Jeden produkt jest tutaj renderowany jako kilka osobnych kafelków
     * (po jednym na kolor). Część aplikacji do badge/label wyszukuje jednak
     * produkt tylko raz i wstawia nakładkę wyłącznie do pierwszego kafelka.
     *
     * Nie opieramy się wyłącznie na nazwach klas. Wykrywamy również dowolny
     * widoczny element absolutnie nałożony na galerię oraz dekoracje wykonane
     * przez ::before / ::after. Następnie odtwarzamy je w pozostałych
     * wariantach tego samego produktu, w dokładnie odpowiadającym miejscu DOM.
     */

    const badgeNamePattern =
      /(badge|badges|label|labels|sticker|stickers|ribbon|ribbons|flag|flags|tag|tags|marker|markers|product.?label|product.?badge|sale.?label|new.?label)/i;

    const badgeExplicitSelector = [
      '.product-badges',
      '.badge',
      '[data-product-badges]',
      '[data-product-badge]',
      '[data-badge-overlay]',
      '[data-label]',
      '[data-product-label]',
      '[data-sticker]',
      '[class*="badge"]',
      '[class*="Badge"]',
      '[class*="label"]',
      '[class*="Label"]',
      '[class*="sticker"]',
      '[class*="Sticker"]',
      '[class*="ribbon"]',
      '[class*="Ribbon"]',
      '[id*="badge"]',
      '[id*="Badge"]',
      '[id*="label"]',
      '[id*="Label"]',
      '[id*="sticker"]',
      '[id*="Sticker"]'
    ].join(',');

    const badgeControlPattern =
      /(arrow|chevron|navigation|pagination|slider|slideshow|carousel|quick.?add|zoom|wishlist|compare|swatch|control|button)/i;

    function isVisibleElement(element) {
      if (!(element instanceof HTMLElement)) return false;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number.parseFloat(style.opacity || '1') <= 0.01
      ) {
        return false;
      }

      return rect.width > 4 && rect.height > 4;
    }

    function elementDescriptor(element) {
      if (!(element instanceof HTMLElement)) return '';

      return [
        element.id || '',
        typeof element.className === 'string' ? element.className : '',
        Array.from(element.attributes)
          .map((attribute) => `${attribute.name}=${attribute.value}`)
          .join(' ')
      ].join(' ');
    }

    function containsPrimaryMedia(element, gallery) {
      if (!(element instanceof HTMLElement) || !(gallery instanceof HTMLElement)) {
        return false;
      }

      const galleryRect = gallery.getBoundingClientRect();

      if (galleryRect.width <= 0 || galleryRect.height <= 0) return false;

      const mediaElements = [];

      if (element.matches('img, picture, video')) {
        mediaElements.push(element);
      }

      element.querySelectorAll('img, picture, video').forEach((media) => {
        mediaElements.push(media);
      });

      return mediaElements.some((media) => {
        const rect = media.getBoundingClientRect();

        return (
          rect.width > galleryRect.width * 0.6 &&
          rect.height > galleryRect.height * 0.6
        );
      });
    }

    function hasVisualBadgeContent(element) {
      if (!(element instanceof HTMLElement)) return false;

      const style = window.getComputedStyle(element);
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const hasGraphic = Boolean(
        element.querySelector('svg, img, canvas') ||
          (style.backgroundImage && style.backgroundImage !== 'none') ||
          (style.backgroundColor &&
            style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
            style.backgroundColor !== 'transparent')
      );

      return (text.length > 0 && text.length <= 100) || hasGraphic;
    }

    function isLikelyOverlay(element, gallery) {
      if (!(element instanceof HTMLElement) || !(gallery instanceof HTMLElement)) {
        return false;
      }

      if (!isVisibleElement(element)) return false;

      const descriptor = elementDescriptor(element);

      if (badgeControlPattern.test(descriptor)) return false;

      if (
        element.matches(
          'button, slideshow-controls, slideshow-arrows, product-swatches, swatches-variant-picker-component'
        )
      ) {
        return false;
      }

      if (containsPrimaryMedia(element, gallery)) return false;

      if (element.matches(badgeExplicitSelector) || badgeNamePattern.test(descriptor)) {
        return true;
      }

      const style = window.getComputedStyle(element);

      if (!['absolute', 'fixed', 'sticky'].includes(style.position)) {
        return false;
      }

      const rect = element.getBoundingClientRect();
      const galleryRect = gallery.getBoundingClientRect();

      if (galleryRect.width <= 0 || galleryRect.height <= 0) return false;

      const overlapsGallery =
        rect.right > galleryRect.left &&
        rect.left < galleryRect.right &&
        rect.bottom > galleryRect.top &&
        rect.top < galleryRect.bottom;

      if (!overlapsGallery) return false;

      const area = rect.width * rect.height;
      const galleryArea = galleryRect.width * galleryRect.height;

      /* Pełnoekranowe warstwy galerii nie są badge'em. */
      if (area > galleryArea * 0.45) return false;

      /* Typowy badge/label jest znacznie mniejszy od zdjęcia. */
      if (
        rect.width > galleryRect.width * 0.75 ||
        rect.height > galleryRect.height * 0.4
      ) {
        return false;
      }

      return hasVisualBadgeContent(element);
    }

    function hasVisiblePseudoBadge(element) {
      if (!(element instanceof HTMLElement)) return false;

      const descriptor = elementDescriptor(element);

      for (const pseudo of ['::before', '::after']) {
        const style = window.getComputedStyle(element, pseudo);
        const content = style.content || '';
        const cleanContent = content.replace(/^['"]|['"]$/g, '').trim();
        const hasContent =
          content !== 'none' &&
          content !== 'normal' &&
          cleanContent !== '';
        const hasBackground =
          (style.backgroundImage && style.backgroundImage !== 'none') ||
          (style.backgroundColor &&
            style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
            style.backgroundColor !== 'transparent');

        if (!hasContent && !hasBackground) continue;

        /*
         * Dla pseudo-elementów bez nazwy badge wymagamy rzeczywistej treści
         * tekstowej. Dzięki temu nie kopiujemy przypadkowych dekoracji, strzałek
         * i warstw technicznych galerii.
         */
        if (badgeNamePattern.test(descriptor)) {
          return true;
        }

        if (
          hasContent &&
          cleanContent.length <= 100 &&
          ['absolute', 'fixed', 'sticky'].includes(style.position)
        ) {
          return true;
        }
      }

      return false;
    }

    function getElementPath(root, element) {
      if (!(root instanceof HTMLElement) || !(element instanceof HTMLElement)) {
        return null;
      }

      if (root === element) return [];

      const path = [];
      let current = element;

      while (current && current !== root) {
        const parent = current.parentElement;

        if (!parent) return null;

        const index = Array.prototype.indexOf.call(parent.children, current);

        if (index < 0) return null;

        path.unshift(index);
        current = parent;
      }

      return current === root ? path : null;
    }

    function getElementByPath(root, path) {
      if (!(root instanceof HTMLElement) || !Array.isArray(path)) return null;

      let current = root;

      for (const index of path) {
        current = current?.children?.[index];

        if (!(current instanceof HTMLElement)) return null;
      }

      return current;
    }

    function makeCloneIdsUnique(clone, variantId) {
      const elements = [clone, ...clone.querySelectorAll('[id]')];
      const idMap = new Map();

      elements.forEach((element) => {
        if (!element.id) return;

        const oldId = element.id;
        const newId = `${oldId}--variant-${variantId}`;

        idMap.set(oldId, newId);
        element.id = newId;
      });

      if (idMap.size === 0) return;

      [clone, ...clone.querySelectorAll('*')].forEach((element) => {
        ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(
          (attributeName) => {
            const value = element.getAttribute?.(attributeName);

            if (value && idMap.has(value)) {
              element.setAttribute(attributeName, idMap.get(value));
            }
          }
        );

        const href = element.getAttribute?.('href');

        if (href && href.startsWith('#')) {
          const oldId = href.slice(1);

          if (idMap.has(oldId)) {
            element.setAttribute('href', `#${idMap.get(oldId)}`);
          }
        }
      });
    }

    function badgeSignature(element) {
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const descriptor = elementDescriptor(element)
        .replace(/\d{4,}/g, '#')
        .replace(/--variant-\d+/g, '--variant-#');

      return `${element.tagName}|${text}|${descriptor}`;
    }

    function findOverlayRoots(card) {
      const gallery = card.querySelector('.card-gallery');

      if (!gallery) return [];

      const allElements = [gallery, ...gallery.querySelectorAll('*')].filter(
        (element) => element instanceof HTMLElement
      );

      const candidates = allElements.filter(
        (element) =>
          !element.closest('[data-collection-badge-clone="true"]') &&
          isLikelyOverlay(element, gallery)
      );

      /*
       * Bierzemy tylko najwyższy sensowny wrapper nakładki. Jeśli zarówno
       * kontener, jak i jego tekst spełniają warunki, kopiujemy sam kontener.
       */
      return candidates.filter(
        (element) =>
          !candidates.some(
            (possibleParent) =>
              possibleParent !== element &&
              possibleParent.contains(element)
          )
      );
    }

    function hasEquivalentOverlay(targetCard, sourceOverlay) {
      const signature = badgeSignature(sourceOverlay);

      const existingClone = Array.from(
        targetCard.querySelectorAll('[data-collection-badge-clone="true"]')
      ).some(
        (clone) => clone.dataset.collectionBadgeSignature === signature
      );

      if (existingClone) return true;

      return findOverlayRoots(targetCard).some(
        (candidate) => badgeSignature(candidate) === signature
      );
    }

    function cloneOverlayToCard(sourceCard, sourceOverlay, targetCard) {
      if (sourceCard === targetCard) return;
      if (hasEquivalentOverlay(targetCard, sourceOverlay)) return;

      const sourceGallery = sourceCard.querySelector('.card-gallery');
      const targetGallery = targetCard.querySelector('.card-gallery');

      if (!sourceGallery || !targetGallery) return;

      const sourceParent = sourceOverlay.parentElement;
      let targetParent = targetGallery;

      if (sourceParent && sourceGallery.contains(sourceParent)) {
        const parentPath = getElementPath(sourceGallery, sourceParent);
        const matchingParent = getElementByPath(targetGallery, parentPath);

        if (matchingParent) {
          targetParent = matchingParent;
        }
      }

      const clone = sourceOverlay.cloneNode(true);
      const variantId = targetCard.dataset.variantId || 'unknown';

      clone.setAttribute('data-collection-badge-clone', 'true');
      clone.setAttribute('data-collection-badge-variant-id', variantId);
      clone.setAttribute(
        'data-collection-badge-signature',
        badgeSignature(sourceOverlay)
      );

      makeCloneIdsUnique(clone, variantId);

      /* Zachowujemy możliwie zbliżoną kolejność dzieci w tym samym wrapperze. */
      const sourceIndex = sourceParent
        ? Array.prototype.indexOf.call(sourceParent.children, sourceOverlay)
        : -1;
      const referenceNode =
        sourceIndex >= 0 ? targetParent.children[sourceIndex] : null;

      if (referenceNode) {
        targetParent.insertBefore(clone, referenceNode);
      } else {
        targetParent.appendChild(clone);
      }
    }

    function mirrorPseudoBadgeOwners(sourceCard, targetCard) {
      const sourceGallery = sourceCard.querySelector('.card-gallery');
      const targetGallery = targetCard.querySelector('.card-gallery');

      if (!sourceGallery || !targetGallery) return;

      const sourceElements = [
        sourceGallery,
        ...sourceGallery.querySelectorAll('*')
      ].filter((element) => element instanceof HTMLElement);

      sourceElements.forEach((sourceElement) => {
        if (!hasVisiblePseudoBadge(sourceElement)) return;

        const path = getElementPath(sourceGallery, sourceElement);
        const targetElement = getElementByPath(targetGallery, path);

        if (!targetElement || targetElement.tagName !== sourceElement.tagName) {
          return;
        }

        /*
         * Jeżeli aplikacja uruchamia badge klasą dodaną tylko do pierwszego
         * kafelka, dodajemy brakujące klasy również do jego odpowiednika.
         */
        sourceElement.classList.forEach((className) => {
          if (!targetElement.classList.contains(className)) {
            targetElement.classList.add(className);
          }
        });

        Array.from(sourceElement.attributes).forEach((attribute) => {
          const name = attribute.name;

          if (
            name === 'class' ||
            name === 'id' ||
            name === 'style' ||
            name === 'src' ||
            name === 'srcset' ||
            name === 'href' ||
            name === 'slide-id' ||
            name === 'data-variant-id'
          ) {
            return;
          }

          if (
            name.startsWith('data-') &&
            !targetElement.hasAttribute(name)
          ) {
            targetElement.setAttribute(name, attribute.value);
          }
        });

        /* Kopiujemy custom properties, bo aplikacje często trzymają tam styl badge. */
        for (let i = 0; i < sourceElement.style.length; i += 1) {
          const propertyName = sourceElement.style[i];

          if (propertyName.startsWith('--')) {
            targetElement.style.setProperty(
              propertyName,
              sourceElement.style.getPropertyValue(propertyName),
              sourceElement.style.getPropertyPriority(propertyName)
            );
          }
        }
      });
    }

    function syncBadgesForProduct(card) {
      const productId = card.dataset.productId;

      if (!productId) return;

      const sectionRoot =
        card.closest('results-list') || document;

      const productCards = Array.from(
        sectionRoot.querySelectorAll(cardSelector)
      ).filter(
        (candidate) => candidate.dataset.productId === productId
      );

      if (productCards.length < 2) return;

      /*
       * Szukamy kafelka, na którym aplikacja rzeczywiście wyrenderowała badge.
       * Nie zakładamy, że zawsze będzie to pierwszy kolor.
       */
      const sourceCards = productCards.filter(
        (productCard) =>
          findOverlayRoots(productCard).length > 0 ||
          Array.from(
            productCard.querySelectorAll('.card-gallery, .card-gallery *')
          ).some((element) => hasVisiblePseudoBadge(element))
      );

      if (sourceCards.length === 0) return;

      const seenOverlaySignatures = new Set();
      const overlaySources = [];

      sourceCards.forEach((sourceCard) => {
        findOverlayRoots(sourceCard).forEach((overlay) => {
          const signature = badgeSignature(overlay);

          if (seenOverlaySignatures.has(signature)) return;

          seenOverlaySignatures.add(signature);
          overlaySources.push({ sourceCard, overlay });
        });
      });

      productCards.forEach((targetCard) => {
        overlaySources.forEach(({ sourceCard, overlay }) => {
          cloneOverlayToCard(sourceCard, overlay, targetCard);
        });

        /* Pseudo-elementy wymagają skopiowania klasy/atrybutów aktywujących. */
        sourceCards.forEach((sourceCard) => {
          if (sourceCard !== targetCard) {
            mirrorPseudoBadgeOwners(sourceCard, targetCard);
          }
        });
      });
    }

    function syncAllProductBadges(root = document) {
      const cards = [];

      if (
        root instanceof HTMLElement &&
        root.matches(cardSelector)
      ) {
        cards.push(root);
      }

      root.querySelectorAll?.(cardSelector).forEach((card) => {
        cards.push(card);
      });

      const processedSections = new Map();

      cards.forEach((card) => {
        const productId = card.dataset.productId;

        if (!productId) return;

        const sectionRoot =
          card.closest('results-list') || document;
        let processedProducts = processedSections.get(sectionRoot);

        if (!processedProducts) {
          processedProducts = new Set();
          processedSections.set(sectionRoot, processedProducts);
        }

        if (processedProducts.has(productId)) return;

        processedProducts.add(productId);
        syncBadgesForProduct(card);
      });
    }

    function initializeVariantCard(card) {
      if (!(card instanceof HTMLElement)) return;

      if (card.dataset.variantCardInitialized === 'true') return;

      card.dataset.variantCardInitialized = 'true';

      updateVariantLinks(card);
      updateSelectedVariant(card);
      updateVariantPrice(card);
      updateVariantImage(card);
      updateAriaLabels(card);
    }

    function initializeVariantCards(root = document) {
      if (
        root instanceof HTMLElement &&
        root.matches(cardSelector)
      ) {
        initializeVariantCard(root);
      }

      root.querySelectorAll?.(cardSelector).forEach((card) => {
        initializeVariantCard(card);
      });
    }

    function initializeCollectionVariantCards() {
      initializeVariantCards(document);

      let initializationScheduled = false;
      let badgeSyncScheduled = false;

      const scheduleBadgeSync = () => {
        if (badgeSyncScheduled) return;

        badgeSyncScheduled = true;

        requestAnimationFrame(() => {
          badgeSyncScheduled = false;
          syncAllProductBadges(document);
        });
      };

      /*
       * Pierwsza próba po zainicjalizowaniu kafelków.
       * Jeśli aplikacja Badges doładuje nakładki później, observer poniżej
       * wykryje zmianę DOM i ponowi synchronizację.
       */
      scheduleBadgeSync();

      const observer = new MutationObserver((mutations) => {
        const containsNewCards = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof HTMLElement &&
              (node.matches(cardSelector) ||
                node.querySelector(cardSelector))
          )
        );

        const containsCardContentChanges = mutations.some(
          (mutation) =>
            mutation.target instanceof HTMLElement &&
            Boolean(mutation.target.closest(cardSelector)) &&
            (
              (mutation.type === 'childList' && mutation.addedNodes.length > 0) ||
              mutation.type === 'attributes'
            )
        );

        if (containsNewCards && !initializationScheduled) {
          initializationScheduled = true;

          requestAnimationFrame(() => {
            initializationScheduled = false;
            initializeVariantCards(document);
            scheduleBadgeSync();
          });
        }

        if (containsCardContentChanges) {
          scheduleBadgeSync();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'data-badge', 'data-label', 'data-product-badge', 'data-product-label']
      });

      /*
       * Część aplikacji ładuje badge dopiero po własnym request/API.
       * Przez pierwsze kilkanaście sekund ponawiamy synchronizację, nawet
       * jeśli aplikacja nie doda nowego elementu, a jedynie zmieni CSS/klasę.
       */
      let badgeRetryCount = 0;
      const badgeRetryTimer = window.setInterval(() => {
        badgeRetryCount += 1;
        syncAllProductBadges(document);

        if (badgeRetryCount >= 20) {
          window.clearInterval(badgeRetryTimer);
        }
      }, 500);

      window.addEventListener(
        'load',
        () => {
          syncAllProductBadges(document);
          window.setTimeout(() => syncAllProductBadges(document), 500);
          window.setTimeout(() => syncAllProductBadges(document), 1500);
          window.setTimeout(() => syncAllProductBadges(document), 3000);
        },
        { once: true }
      );

      document.addEventListener('shopify:section:load', (event) => {
        initializeVariantCards(event.target);
        requestAnimationFrame(() => {
          syncAllProductBadges(event.target);
        });
      });

      /*
       * results-list może podmieniać zawartość po filtrach / sortowaniu /
       * infinite scroll. Observer jest podstawą, a te eventy są dodatkowym
       * zabezpieczeniem dla motywu Horizon.
       */
      ['shopify:section:reorder', 'shopify:section:select'].forEach((eventName) => {
        document.addEventListener(eventName, () => {
          requestAnimationFrame(() => {
            initializeVariantCards(document);
            syncAllProductBadges(document);
          });
        });
      });
    }

    const currentUrl = new URL(window.location.href);

    if (currentUrl.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(
            currentUrl.hash.slice(1)
          );

          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeCollectionVariantCards,
        { once: true }
      );
    } else {
      initializeCollectionVariantCards();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cardSelector = '[data-collection-variant-card]';

    function updateVariantLinks(card) {
      const variantUrl = card.dataset.variantUrl;
      const productUrl = card.dataset.productUrl;

      if (!variantUrl || !productUrl) return;

      let productPath;

      try {
        productPath = new URL(productUrl, window.location.origin).pathname;
      } catch (error) {
        return;
      }

      card.querySelectorAll('a[href]').forEach((link) => {
        try {
          const currentUrl = new URL(link.href, window.location.origin);

          if (currentUrl.pathname === productPath) {
            link.href = variantUrl;
          }
        } catch (error) {
          // Pomijamy linki, których nie można przetworzyć.
        }
      });

      const productCard = card.querySelector('product-card');

      if (!productCard) return;

      const productCardLink = productCard.querySelector('[ref="productCardLink"]');

      if (productCardLink) {
        productCardLink.href = variantUrl;

        if (productCardLink.id) {
          productCardLink.id = `${productCardLink.id}-${card.dataset.variantId}`;
        }
      }

      if (productCard.id) {
        productCard.id = `${productCard.id}-${card.dataset.variantId}`;
      }

      const variantImageUrl = card.dataset.variantImageUrl;

      productCard.setAttribute('data-product-id', card.dataset.productId || '');
      productCard.setAttribute('data-variant-id', card.dataset.variantId || '');

      const gallery = card.querySelector('.card-gallery');

      if (gallery) {
        gallery.setAttribute('data-variant-id', card.dataset.variantId || '');
      }

      if (variantImageUrl) {
        productCard.setAttribute('data-featured-media-url', variantImageUrl);
      }
    }

    function updateSelectedVariant(card) {
      const variantId = card.dataset.variantId;
      const available = card.dataset.variantAvailable === 'true';
      const productCard = card.querySelector('product-card');

      if (!variantId || !productCard) return;

      /*
       * Usuwamy zaznaczenie domyślnego wariantu z ukrytych próbek,
       * żeby szybki podgląd korzystał z wariantu przypisanego do kafelka.
       */
      productCard
        .querySelectorAll('input[type="radio"][data-variant-id]:checked')
        .forEach((input) => {
          input.checked = false;
        });

      let selectedVariantInput = productCard.querySelector(
        '[data-collection-selected-variant]'
      );

      if (!selectedVariantInput) {
        selectedVariantInput = document.createElement('input');
        selectedVariantInput.type = 'radio';
        selectedVariantInput.hidden = true;
        selectedVariantInput.checked = true;
        selectedVariantInput.setAttribute(
          'data-collection-selected-variant',
          ''
        );

        productCard.appendChild(selectedVariantInput);
      }

      selectedVariantInput.name = `collection-variant-${card.dataset.productId}-${variantId}`;
      selectedVariantInput.value = variantId;
      selectedVariantInput.dataset.variantId = variantId;
      selectedVariantInput.checked = true;

      /*
       * Formularz szybkiego dodawania do koszyka.
       */
      productCard
        .querySelectorAll('input[name="id"]')
        .forEach((input) => {
          input.value = variantId;
          input.disabled = !available;
        });

      productCard
        .querySelectorAll(
          '.quick-add__button--add, .add-to-cart-button[type="submit"]'
        )
        .forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
    }

    function updateVariantPrice(card) {
      const priceTemplate = card.querySelector(
        'template[data-collection-variant-price]'
      );

      if (!priceTemplate) return;

      card
        .querySelectorAll('[ref="priceContainer"]')
        .forEach((priceContainer) => {
          priceContainer.replaceChildren(
            priceTemplate.content.cloneNode(true)
          );
        });

      card
        .querySelectorAll('[ref="volumePricingNote"]')
        .forEach((volumePricingNote) => {
          volumePricingNote.hidden = true;
        });
    }

    function replaceImageFallback(card) {
      const imageUrl = card.dataset.variantImageUrl;
      const imageSrcset = card.dataset.variantImageSrcset;
      const imageAlt = card.dataset.variantImageAlt;

      if (!imageUrl) return;

      const image = card.querySelector(
        '.card-gallery .product-media__image'
      );

      if (!image) return;

      image.src = imageUrl;

      if (imageSrcset) {
        image.srcset = imageSrcset;
      }

      if (imageAlt) {
        image.alt = imageAlt;
      }

      image.setAttribute('data-max-resolution', imageUrl);

      const picture = image.closest('picture');

      if (picture && imageSrcset) {
        picture.querySelectorAll('source').forEach((source) => {
          source.srcset = imageSrcset;
        });
      }
    }

    function updateVariantImage(card) {
      const mediaId = card.dataset.variantMediaId;
      const slideshow = card.querySelector(
        '.card-gallery slideshow-component'
      );
      const gallery = card.querySelector('.card-gallery');

      /*
       * Wyłączamy zmianę zdjęcia po najechaniu, ponieważ każdy kafelek
       * ma pozostać przypisany do konkretnego koloru.
       */
      if (gallery && card.dataset.hasColorOption === 'true') {
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
      }

      if (!slideshow || !mediaId) {
        replaceImageFallback(card);
        return;
      }

      const slides = Array.from(
        slideshow.querySelectorAll('slideshow-slide')
      );

      const selectedSlide = slides.find(
        (slide) => slide.getAttribute('slide-id') === mediaId
      );

      if (!selectedSlide) {
        replaceImageFallback(card);
        return;
      }

      const selectedSlideIndex = slides.indexOf(selectedSlide);

      if (selectedSlideIndex >= 0) {
        slideshow.setAttribute(
          'initial-slide',
          String(selectedSlideIndex)
        );
      }

      const selectSlide = (attempt = 0) => {
        if (
          typeof slideshow.select === 'function' &&
          slideshow.isConnected
        ) {
          slideshow.select(
            { id: mediaId },
            undefined,
            { animate: false }
          );

          return;
        }

        if (attempt < 10) {
          requestAnimationFrame(() => {
            selectSlide(attempt + 1);
          });
        } else {
          replaceImageFallback(card);
        }
      };

      if (window.customElements) {
        customElements
          .whenDefined('slideshow-component')
          .then(() => {
            requestAnimationFrame(() => {
              selectSlide();
            });
          })
          .catch(() => {
            replaceImageFallback(card);
          });
      } else {
        replaceImageFallback(card);
      }
    }

    function updateAriaLabels(card) {
      const productTitle = card.dataset.productTitle;
      const colorName = card.dataset.colorName;

      if (!productTitle) return;

      const ariaLabel =
        colorName && card.dataset.hasColorOption === 'true'
          ? `${productTitle} – ${colorName}`
          : productTitle;

      card
        .querySelectorAll(
          '[ref="productCardLink"], [ref="cardGalleryLink"]'
        )
        .forEach((link) => {
          link.setAttribute('aria-label', ariaLabel);
        });
    }

    /*
     * BADGES / LABELS / STICKERS
     *
     * Jeden produkt jest tutaj renderowany jako kilka osobnych kafelków
     * (po jednym na kolor). Część aplikacji do badge/label wyszukuje jednak
     * produkt tylko raz i wstawia nakładkę wyłącznie do pierwszego kafelka.
     *
     * Nie opieramy się wyłącznie na nazwach klas. Wykrywamy również dowolny
     * widoczny element absolutnie nałożony na galerię oraz dekoracje wykonane
     * przez ::before / ::after. Następnie odtwarzamy je w pozostałych
     * wariantach tego samego produktu, w dokładnie odpowiadającym miejscu DOM.
     */

    const badgeNamePattern =
      /(badge|badges|label|labels|sticker|stickers|ribbon|ribbons|flag|flags|tag|tags|marker|markers|product.?label|product.?badge|sale.?label|new.?label)/i;

    const badgeExplicitSelector = [
      '.product-badges',
      '.badge',
      '[data-product-badges]',
      '[data-product-badge]',
      '[data-badge-overlay]',
      '[data-label]',
      '[data-product-label]',
      '[data-sticker]',
      '[class*="badge"]',
      '[class*="Badge"]',
      '[class*="label"]',
      '[class*="Label"]',
      '[class*="sticker"]',
      '[class*="Sticker"]',
      '[class*="ribbon"]',
      '[class*="Ribbon"]',
      '[id*="badge"]',
      '[id*="Badge"]',
      '[id*="label"]',
      '[id*="Label"]',
      '[id*="sticker"]',
      '[id*="Sticker"]'
    ].join(',');

    const badgeControlPattern =
      /(arrow|chevron|navigation|pagination|slider|slideshow|carousel|quick.?add|zoom|wishlist|compare|swatch|control|button)/i;

    function isVisibleElement(element) {
      if (!(element instanceof HTMLElement)) return false;

      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();

      if (
        style.display === 'none' ||
        style.visibility === 'hidden' ||
        Number.parseFloat(style.opacity || '1') <= 0.01
      ) {
        return false;
      }

      return rect.width > 4 && rect.height > 4;
    }

    function elementDescriptor(element) {
      if (!(element instanceof HTMLElement)) return '';

      return [
        element.id || '',
        typeof element.className === 'string' ? element.className : '',
        Array.from(element.attributes)
          .map((attribute) => `${attribute.name}=${attribute.value}`)
          .join(' ')
      ].join(' ');
    }

    function containsPrimaryMedia(element, gallery) {
      if (!(element instanceof HTMLElement) || !(gallery instanceof HTMLElement)) {
        return false;
      }

      const galleryRect = gallery.getBoundingClientRect();

      if (galleryRect.width <= 0 || galleryRect.height <= 0) return false;

      const mediaElements = [];

      if (element.matches('img, picture, video')) {
        mediaElements.push(element);
      }

      element.querySelectorAll('img, picture, video').forEach((media) => {
        mediaElements.push(media);
      });

      return mediaElements.some((media) => {
        const rect = media.getBoundingClientRect();

        return (
          rect.width > galleryRect.width * 0.6 &&
          rect.height > galleryRect.height * 0.6
        );
      });
    }

    function hasVisualBadgeContent(element) {
      if (!(element instanceof HTMLElement)) return false;

      const style = window.getComputedStyle(element);
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const hasGraphic = Boolean(
        element.querySelector('svg, img, canvas') ||
          (style.backgroundImage && style.backgroundImage !== 'none') ||
          (style.backgroundColor &&
            style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
            style.backgroundColor !== 'transparent')
      );

      return (text.length > 0 && text.length <= 100) || hasGraphic;
    }

    function isLikelyOverlay(element, gallery) {
      if (!(element instanceof HTMLElement) || !(gallery instanceof HTMLElement)) {
        return false;
      }

      if (!isVisibleElement(element)) return false;

      const descriptor = elementDescriptor(element);

      if (badgeControlPattern.test(descriptor)) return false;

      if (
        element.matches(
          'button, slideshow-controls, slideshow-arrows, product-swatches, swatches-variant-picker-component'
        )
      ) {
        return false;
      }

      if (containsPrimaryMedia(element, gallery)) return false;

      if (element.matches(badgeExplicitSelector) || badgeNamePattern.test(descriptor)) {
        return true;
      }

      const style = window.getComputedStyle(element);

      if (!['absolute', 'fixed', 'sticky'].includes(style.position)) {
        return false;
      }

      const rect = element.getBoundingClientRect();
      const galleryRect = gallery.getBoundingClientRect();

      if (galleryRect.width <= 0 || galleryRect.height <= 0) return false;

      const overlapsGallery =
        rect.right > galleryRect.left &&
        rect.left < galleryRect.right &&
        rect.bottom > galleryRect.top &&
        rect.top < galleryRect.bottom;

      if (!overlapsGallery) return false;

      const area = rect.width * rect.height;
      const galleryArea = galleryRect.width * galleryRect.height;

      /* Pełnoekranowe warstwy galerii nie są badge'em. */
      if (area > galleryArea * 0.45) return false;

      /* Typowy badge/label jest znacznie mniejszy od zdjęcia. */
      if (
        rect.width > galleryRect.width * 0.75 ||
        rect.height > galleryRect.height * 0.4
      ) {
        return false;
      }

      return hasVisualBadgeContent(element);
    }

    function hasVisiblePseudoBadge(element) {
      if (!(element instanceof HTMLElement)) return false;

      const descriptor = elementDescriptor(element);

      for (const pseudo of ['::before', '::after']) {
        const style = window.getComputedStyle(element, pseudo);
        const content = style.content || '';
        const cleanContent = content.replace(/^['"]|['"]$/g, '').trim();
        const hasContent =
          content !== 'none' &&
          content !== 'normal' &&
          cleanContent !== '';
        const hasBackground =
          (style.backgroundImage && style.backgroundImage !== 'none') ||
          (style.backgroundColor &&
            style.backgroundColor !== 'rgba(0, 0, 0, 0)' &&
            style.backgroundColor !== 'transparent');

        if (!hasContent && !hasBackground) continue;

        /*
         * Dla pseudo-elementów bez nazwy badge wymagamy rzeczywistej treści
         * tekstowej. Dzięki temu nie kopiujemy przypadkowych dekoracji, strzałek
         * i warstw technicznych galerii.
         */
        if (badgeNamePattern.test(descriptor)) {
          return true;
        }

        if (
          hasContent &&
          cleanContent.length <= 100 &&
          ['absolute', 'fixed', 'sticky'].includes(style.position)
        ) {
          return true;
        }
      }

      return false;
    }

    function getElementPath(root, element) {
      if (!(root instanceof HTMLElement) || !(element instanceof HTMLElement)) {
        return null;
      }

      if (root === element) return [];

      const path = [];
      let current = element;

      while (current && current !== root) {
        const parent = current.parentElement;

        if (!parent) return null;

        const index = Array.prototype.indexOf.call(parent.children, current);

        if (index < 0) return null;

        path.unshift(index);
        current = parent;
      }

      return current === root ? path : null;
    }

    function getElementByPath(root, path) {
      if (!(root instanceof HTMLElement) || !Array.isArray(path)) return null;

      let current = root;

      for (const index of path) {
        current = current?.children?.[index];

        if (!(current instanceof HTMLElement)) return null;
      }

      return current;
    }

    function makeCloneIdsUnique(clone, variantId) {
      const elements = [clone, ...clone.querySelectorAll('[id]')];
      const idMap = new Map();

      elements.forEach((element) => {
        if (!element.id) return;

        const oldId = element.id;
        const newId = `${oldId}--variant-${variantId}`;

        idMap.set(oldId, newId);
        element.id = newId;
      });

      if (idMap.size === 0) return;

      [clone, ...clone.querySelectorAll('*')].forEach((element) => {
        ['for', 'aria-controls', 'aria-labelledby', 'aria-describedby'].forEach(
          (attributeName) => {
            const value = element.getAttribute?.(attributeName);

            if (value && idMap.has(value)) {
              element.setAttribute(attributeName, idMap.get(value));
            }
          }
        );

        const href = element.getAttribute?.('href');

        if (href && href.startsWith('#')) {
          const oldId = href.slice(1);

          if (idMap.has(oldId)) {
            element.setAttribute('href', `#${idMap.get(oldId)}`);
          }
        }
      });
    }

    function badgeSignature(element) {
      const text = (element.textContent || '').replace(/\s+/g, ' ').trim();
      const descriptor = elementDescriptor(element)
        .replace(/\d{4,}/g, '#')
        .replace(/--variant-\d+/g, '--variant-#');

      return `${element.tagName}|${text}|${descriptor}`;
    }

    function findOverlayRoots(card) {
      const gallery = card.querySelector('.card-gallery');

      if (!gallery) return [];

      const allElements = [gallery, ...gallery.querySelectorAll('*')].filter(
        (element) => element instanceof HTMLElement
      );

      const candidates = allElements.filter(
        (element) =>
          !element.closest('[data-collection-badge-clone="true"]') &&
          isLikelyOverlay(element, gallery)
      );

      /*
       * Bierzemy tylko najwyższy sensowny wrapper nakładki. Jeśli zarówno
       * kontener, jak i jego tekst spełniają warunki, kopiujemy sam kontener.
       */
      return candidates.filter(
        (element) =>
          !candidates.some(
            (possibleParent) =>
              possibleParent !== element &&
              possibleParent.contains(element)
          )
      );
    }

    function hasEquivalentOverlay(targetCard, sourceOverlay) {
      const signature = badgeSignature(sourceOverlay);

      const existingClone = Array.from(
        targetCard.querySelectorAll('[data-collection-badge-clone="true"]')
      ).some(
        (clone) => clone.dataset.collectionBadgeSignature === signature
      );

      if (existingClone) return true;

      return findOverlayRoots(targetCard).some(
        (candidate) => badgeSignature(candidate) === signature
      );
    }

    function cloneOverlayToCard(sourceCard, sourceOverlay, targetCard) {
      if (sourceCard === targetCard) return;
      if (hasEquivalentOverlay(targetCard, sourceOverlay)) return;

      const sourceGallery = sourceCard.querySelector('.card-gallery');
      const targetGallery = targetCard.querySelector('.card-gallery');

      if (!sourceGallery || !targetGallery) return;

      const sourceParent = sourceOverlay.parentElement;
      let targetParent = targetGallery;

      if (sourceParent && sourceGallery.contains(sourceParent)) {
        const parentPath = getElementPath(sourceGallery, sourceParent);
        const matchingParent = getElementByPath(targetGallery, parentPath);

        if (matchingParent) {
          targetParent = matchingParent;
        }
      }

      const clone = sourceOverlay.cloneNode(true);
      const variantId = targetCard.dataset.variantId || 'unknown';

      clone.setAttribute('data-collection-badge-clone', 'true');
      clone.setAttribute('data-collection-badge-variant-id', variantId);
      clone.setAttribute(
        'data-collection-badge-signature',
        badgeSignature(sourceOverlay)
      );

      makeCloneIdsUnique(clone, variantId);

      /* Zachowujemy możliwie zbliżoną kolejność dzieci w tym samym wrapperze. */
      const sourceIndex = sourceParent
        ? Array.prototype.indexOf.call(sourceParent.children, sourceOverlay)
        : -1;
      const referenceNode =
        sourceIndex >= 0 ? targetParent.children[sourceIndex] : null;

      if (referenceNode) {
        targetParent.insertBefore(clone, referenceNode);
      } else {
        targetParent.appendChild(clone);
      }
    }

    function mirrorPseudoBadgeOwners(sourceCard, targetCard) {
      const sourceGallery = sourceCard.querySelector('.card-gallery');
      const targetGallery = targetCard.querySelector('.card-gallery');

      if (!sourceGallery || !targetGallery) return;

      const sourceElements = [
        sourceGallery,
        ...sourceGallery.querySelectorAll('*')
      ].filter((element) => element instanceof HTMLElement);

      sourceElements.forEach((sourceElement) => {
        if (!hasVisiblePseudoBadge(sourceElement)) return;

        const path = getElementPath(sourceGallery, sourceElement);
        const targetElement = getElementByPath(targetGallery, path);

        if (!targetElement || targetElement.tagName !== sourceElement.tagName) {
          return;
        }

        /*
         * Jeżeli aplikacja uruchamia badge klasą dodaną tylko do pierwszego
         * kafelka, dodajemy brakujące klasy również do jego odpowiednika.
         */
        sourceElement.classList.forEach((className) => {
          if (!targetElement.classList.contains(className)) {
            targetElement.classList.add(className);
          }
        });

        Array.from(sourceElement.attributes).forEach((attribute) => {
          const name = attribute.name;

          if (
            name === 'class' ||
            name === 'id' ||
            name === 'style' ||
            name === 'src' ||
            name === 'srcset' ||
            name === 'href' ||
            name === 'slide-id' ||
            name === 'data-variant-id'
          ) {
            return;
          }

          if (
            name.startsWith('data-') &&
            !targetElement.hasAttribute(name)
          ) {
            targetElement.setAttribute(name, attribute.value);
          }
        });

        /* Kopiujemy custom properties, bo aplikacje często trzymają tam styl badge. */
        for (let i = 0; i < sourceElement.style.length; i += 1) {
          const propertyName = sourceElement.style[i];

          if (propertyName.startsWith('--')) {
            targetElement.style.setProperty(
              propertyName,
              sourceElement.style.getPropertyValue(propertyName),
              sourceElement.style.getPropertyPriority(propertyName)
            );
          }
        }
      });
    }

    function syncBadgesForProduct(card) {
      const productId = card.dataset.productId;

      if (!productId) return;

      const sectionRoot =
        card.closest('[data-testid="product-list"]') || document;

      const productCards = Array.from(
        sectionRoot.querySelectorAll(cardSelector)
      ).filter(
        (candidate) => candidate.dataset.productId === productId
      );

      if (productCards.length < 2) return;

      /*
       * Szukamy kafelka, na którym aplikacja rzeczywiście wyrenderowała badge.
       * Nie zakładamy, że zawsze będzie to pierwszy kolor.
       */
      const sourceCards = productCards.filter(
        (productCard) =>
          findOverlayRoots(productCard).length > 0 ||
          Array.from(
            productCard.querySelectorAll('.card-gallery, .card-gallery *')
          ).some((element) => hasVisiblePseudoBadge(element))
      );

      if (sourceCards.length === 0) return;

      const seenOverlaySignatures = new Set();
      const overlaySources = [];

      sourceCards.forEach((sourceCard) => {
        findOverlayRoots(sourceCard).forEach((overlay) => {
          const signature = badgeSignature(overlay);

          if (seenOverlaySignatures.has(signature)) return;

          seenOverlaySignatures.add(signature);
          overlaySources.push({ sourceCard, overlay });
        });
      });

      productCards.forEach((targetCard) => {
        overlaySources.forEach(({ sourceCard, overlay }) => {
          cloneOverlayToCard(sourceCard, overlay, targetCard);
        });

        /* Pseudo-elementy wymagają skopiowania klasy/atrybutów aktywujących. */
        sourceCards.forEach((sourceCard) => {
          if (sourceCard !== targetCard) {
            mirrorPseudoBadgeOwners(sourceCard, targetCard);
          }
        });
      });
    }

    function syncAllProductBadges(root = document) {
      const cards = [];

      if (
        root instanceof HTMLElement &&
        root.matches(cardSelector)
      ) {
        cards.push(root);
      }

      root.querySelectorAll?.(cardSelector).forEach((card) => {
        cards.push(card);
      });

      const processedSections = new Map();

      cards.forEach((card) => {
        const productId = card.dataset.productId;

        if (!productId) return;

        const sectionRoot =
          card.closest('[data-testid="product-list"]') || document;
        let processedProducts = processedSections.get(sectionRoot);

        if (!processedProducts) {
          processedProducts = new Set();
          processedSections.set(sectionRoot, processedProducts);
        }

        if (processedProducts.has(productId)) return;

        processedProducts.add(productId);
        syncBadgesForProduct(card);
      });
    }

    function initializeVariantCard(card) {
      if (!(card instanceof HTMLElement)) return;

      if (card.dataset.variantCardInitialized === 'true') return;

      card.dataset.variantCardInitialized = 'true';

      updateVariantLinks(card);
      updateSelectedVariant(card);
      updateVariantPrice(card);
      updateVariantImage(card);
      updateAriaLabels(card);
    }

    function initializeVariantCards(root = document) {
      if (
        root instanceof HTMLElement &&
        root.matches(cardSelector)
      ) {
        initializeVariantCard(root);
      }

      root.querySelectorAll?.(cardSelector).forEach((card) => {
        initializeVariantCard(card);
      });
    }

    function initializeCollectionVariantCards() {
      initializeVariantCards(document);

      let initializationScheduled = false;
      let badgeSyncScheduled = false;

      const scheduleBadgeSync = () => {
        if (badgeSyncScheduled) return;

        badgeSyncScheduled = true;

        requestAnimationFrame(() => {
          badgeSyncScheduled = false;
          syncAllProductBadges(document);
        });
      };

      /*
       * Pierwsza próba po zainicjalizowaniu kafelków.
       * Jeśli aplikacja Badges doładuje nakładki później, observer poniżej
       * wykryje zmianę DOM i ponowi synchronizację.
       */
      scheduleBadgeSync();

      const observer = new MutationObserver((mutations) => {
        const containsNewCards = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof HTMLElement &&
              (node.matches(cardSelector) ||
                node.querySelector(cardSelector))
          )
        );

        const containsCardContentChanges = mutations.some(
          (mutation) =>
            mutation.target instanceof HTMLElement &&
            Boolean(mutation.target.closest(cardSelector)) &&
            (
              (mutation.type === 'childList' && mutation.addedNodes.length > 0) ||
              mutation.type === 'attributes'
            )
        );

        if (containsNewCards && !initializationScheduled) {
          initializationScheduled = true;

          requestAnimationFrame(() => {
            initializationScheduled = false;
            initializeVariantCards(document);
            scheduleBadgeSync();
          });
        }

        if (containsCardContentChanges) {
          scheduleBadgeSync();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'data-badge', 'data-label', 'data-product-badge', 'data-product-label']
      });

      /*
       * Część aplikacji ładuje badge dopiero po własnym request/API.
       * Przez pierwsze kilkanaście sekund ponawiamy synchronizację, nawet
       * jeśli aplikacja nie doda nowego elementu, a jedynie zmieni CSS/klasę.
       */
      let badgeRetryCount = 0;
      const badgeRetryTimer = window.setInterval(() => {
        badgeRetryCount += 1;
        syncAllProductBadges(document);

        if (badgeRetryCount >= 20) {
          window.clearInterval(badgeRetryTimer);
        }
      }, 500);

      window.addEventListener(
        'load',
        () => {
          syncAllProductBadges(document);
          window.setTimeout(() => syncAllProductBadges(document), 500);
          window.setTimeout(() => syncAllProductBadges(document), 1500);
          window.setTimeout(() => syncAllProductBadges(document), 3000);
        },
        { once: true }
      );

      document.addEventListener('shopify:section:load', (event) => {
        initializeVariantCards(event.target);
        requestAnimationFrame(() => {
          syncAllProductBadges(event.target);
        });
      });
    }

    const currentUrl = new URL(window.location.href);

    if (currentUrl.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(
            currentUrl.hash.slice(1)
          );

          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeCollectionVariantCards,
        { once: true }
      );
    } else {
      initializeCollectionVariantCards();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const cardSelector = '[data-collection-variant-card]';

    function updateVariantLinks(card) {
      const variantUrl = card.dataset.variantUrl;
      const productUrl = card.dataset.productUrl;

      if (!variantUrl || !productUrl) return;

      let productPath;

      try {
        productPath = new URL(productUrl, window.location.origin).pathname;
      } catch (error) {
        return;
      }

      card.querySelectorAll('a[href]').forEach((link) => {
        try {
          const currentUrl = new URL(link.href, window.location.origin);

          if (currentUrl.pathname === productPath) {
            link.href = variantUrl;
          }
        } catch (error) {
          // Pomijamy linki, których nie można przetworzyć.
        }
      });

      const productCard = card.querySelector('product-card');

      if (!productCard) return;

      const productCardLink = productCard.querySelector('[ref="productCardLink"]');

      if (typeof productCard.applyVariantToLinks === 'function') {
        productCard.applyVariantToLinks(card.dataset.variantId);
      }

      if (productCardLink) {
        productCardLink.href = variantUrl;

        if (
          productCardLink.id &&
          !productCardLink.id.endsWith(`-${card.dataset.variantId}`)
        ) {
          productCardLink.id = `${productCardLink.id}-${card.dataset.variantId}`;
        }
      }

      if (
        productCard.id &&
        !productCard.id.endsWith(`-${card.dataset.variantId}`)
      ) {
        productCard.id = `${productCard.id}-${card.dataset.variantId}`;
      }

      const variantImageUrl = card.dataset.variantImageUrl;

      if (variantImageUrl) {
        productCard.setAttribute('data-featured-media-url', variantImageUrl);
      }
    }

    function updateSelectedVariant(card) {
      const variantId = card.dataset.variantId;
      const available = card.dataset.variantAvailable === 'true';
      const productCard = card.querySelector('product-card');

      if (!variantId || !productCard) return;

      /*
       * Usuwamy zaznaczenie domyślnego wariantu z ukrytych próbek,
       * żeby szybki podgląd korzystał z wariantu przypisanego do kafelka.
       */
      productCard
        .querySelectorAll('input[type="radio"][data-variant-id]:checked')
        .forEach((input) => {
          input.checked = false;
        });

      let selectedVariantInput = productCard.querySelector(
        '[data-collection-selected-variant]'
      );

      if (!selectedVariantInput) {
        selectedVariantInput = document.createElement('input');
        selectedVariantInput.type = 'radio';
        selectedVariantInput.hidden = true;
        selectedVariantInput.checked = true;
        selectedVariantInput.setAttribute(
          'data-collection-selected-variant',
          ''
        );

        productCard.appendChild(selectedVariantInput);
      }

      selectedVariantInput.name = `collection-variant-${card.dataset.productId}-${variantId}`;
      selectedVariantInput.value = variantId;
      selectedVariantInput.dataset.variantId = variantId;
      selectedVariantInput.checked = true;

      /*
       * Formularz szybkiego dodawania do koszyka.
       */
      productCard
        .querySelectorAll('input[name="id"]')
        .forEach((input) => {
          input.value = variantId;
          input.disabled = !available;
        });

      productCard
        .querySelectorAll(
          '.quick-add__button--add, .add-to-cart-button[type="submit"]'
        )
        .forEach((button) => {
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
        });
    }

    function updateVariantPrice(card) {
      const priceTemplate = card.querySelector(
        'template[data-collection-variant-price]'
      );

      if (!priceTemplate) return;

      card
        .querySelectorAll('[ref="priceContainer"]')
        .forEach((priceContainer) => {
          priceContainer.replaceChildren(
            priceTemplate.content.cloneNode(true)
          );
        });

      card
        .querySelectorAll('[ref="volumePricingNote"]')
        .forEach((volumePricingNote) => {
          volumePricingNote.hidden = true;
        });
    }

    function replaceImageFallback(card) {
      const imageUrl = card.dataset.variantImageUrl;
      const imageSrcset = card.dataset.variantImageSrcset;
      const imageAlt = card.dataset.variantImageAlt;

      if (!imageUrl) return;

      const image = card.querySelector(
        '.card-gallery .product-media__image'
      );

      if (!image) return;

      image.src = imageUrl;

      if (imageSrcset) {
        image.srcset = imageSrcset;
      }

      if (imageAlt) {
        image.alt = imageAlt;
      }

      image.setAttribute('data-max-resolution', imageUrl);

      const picture = image.closest('picture');

      if (picture && imageSrcset) {
        picture.querySelectorAll('source').forEach((source) => {
          source.srcset = imageSrcset;
        });
      }
    }

    function updateVariantImage(card) {
      const mediaId = card.dataset.variantMediaId;
      const slideshow = card.querySelector(
        '.card-gallery slideshow-component'
      );
      const gallery = card.querySelector('.card-gallery');

      /*
       * Wyłączamy zmianę zdjęcia po najechaniu, ponieważ każdy kafelek
       * ma pozostać przypisany do konkretnego koloru.
       */
      if (gallery && card.dataset.hasColorOption === 'true') {
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');
      }

      if (!slideshow || !mediaId) {
        replaceImageFallback(card);
        return;
      }

      const slides = Array.from(
        slideshow.querySelectorAll('slideshow-slide')
      );

      const selectedSlide = slides.find(
        (slide) => slide.getAttribute('slide-id') === mediaId
      );

      if (!selectedSlide) {
        replaceImageFallback(card);
        return;
      }

      const selectedSlideIndex = slides.indexOf(selectedSlide);

      if (selectedSlideIndex >= 0) {
        slideshow.setAttribute(
          'initial-slide',
          String(selectedSlideIndex)
        );
      }

      const selectSlide = (attempt = 0) => {
        if (
          typeof slideshow.select === 'function' &&
          slideshow.isConnected
        ) {
          slideshow.select(
            { id: mediaId },
            undefined,
            { animate: false }
          );

          return;
        }

        if (attempt < 10) {
          requestAnimationFrame(() => {
            selectSlide(attempt + 1);
          });
        } else {
          replaceImageFallback(card);
        }
      };

      if (window.customElements) {
        customElements
          .whenDefined('slideshow-component')
          .then(() => {
            requestAnimationFrame(() => {
              selectSlide();
            });
          })
          .catch(() => {
            replaceImageFallback(card);
          });
      } else {
        replaceImageFallback(card);
      }
    }

    function updateAriaLabels(card) {
      const productTitle = card.dataset.productTitle;
      const colorName = card.dataset.colorName;

      if (!productTitle) return;

      const ariaLabel =
        colorName && card.dataset.hasColorOption === 'true'
          ? `${productTitle} – ${colorName}`
          : productTitle;

      card
        .querySelectorAll(
          '[ref="productCardLink"], [ref="cardGalleryLink"]'
        )
        .forEach((link) => {
          link.setAttribute('aria-label', ariaLabel);
        });
    }

    function initializeVariantCard(card) {
      if (!(card instanceof HTMLElement) || !card.isConnected) return;

      updateVariantLinks(card);
      updateSelectedVariant(card);
      updateVariantPrice(card);
      updateVariantImage(card);
      updateAriaLabels(card);

      card.dataset.variantCardInitialized = 'true';
    }

    function scheduleVariantCard(card) {
      if (!(card instanceof HTMLElement)) return;

      initializeVariantCard(card);

      [50, 200, 600].forEach((delay) => {
        window.setTimeout(() => initializeVariantCard(card), delay);
      });

      if (window.customElements) {
        customElements
          .whenDefined('product-card')
          .then(() => requestAnimationFrame(() => initializeVariantCard(card)))
          .catch(() => {});
      }
    }

    function initializeVariantCards(root = document) {
      if (
        root instanceof HTMLElement &&
        root.matches(cardSelector)
      ) {
        scheduleVariantCard(root);
      }

      root.querySelectorAll?.(cardSelector).forEach((card) => {
        scheduleVariantCard(card);
      });
    }

    function initializeCollectionVariantCards() {
      initializeVariantCards(document);

      let initializationScheduled = false;

      const observer = new MutationObserver((mutations) => {
        const containsNewCards = mutations.some((mutation) =>
          Array.from(mutation.addedNodes).some(
            (node) =>
              node instanceof HTMLElement &&
              (node.matches(cardSelector) ||
                node.querySelector(cardSelector))
          )
        );

        if (!containsNewCards || initializationScheduled) return;

        initializationScheduled = true;

        requestAnimationFrame(() => {
          initializationScheduled = false;
          initializeVariantCards(document);
        });
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      document.addEventListener('shopify:section:load', (event) => {
        initializeVariantCards(event.target);
      });
    }

    const currentUrl = new URL(window.location.href);

    if (currentUrl.hash) {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          const card = document.getElementById(
            currentUrl.hash.slice(1)
          );

          if (card) {
            card.scrollIntoView({ behavior: 'instant' });
          }
        },
        { once: true }
      );
    }

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        initializeCollectionVariantCards,
        { once: true }
      );
    } else {
      initializeCollectionVariantCards();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
